import { NavigationGuardNext } from 'vue-router/types/router'
import { RouteConfigType } from '@/router/types/RouteConfigType'
import { Store, Commit } from 'vuex'
import Permission from '@/utilities/auth/permission/Permission'
import Path from '@/utilities/bid/enums/Path'

const permission = async ({
  to,
  from,
  next,
  store,
}: {
  to: RouteConfigType
  from: RouteConfigType
  next: NavigationGuardNext
  store: Store<Commit>
}) => {
  if (to?.meta?.serviceName) {
    // After reloading the page we don't have any permissions in user (store.getters['Auth/permissions'])
    if (!store.getters['Auth/permissions'].length) {
      await store.dispatch('Dashboard/fetchPermission')
    }

    const permission = new Permission(store.getters['Auth/permissions'])

    if (!permission.allow(to.meta.serviceName, to?.meta?.permissions ?? [])) {
      store.commit('Dashboard/setFeedback', {
        message: to?.meta?.errorMessage ?? 'Access denied',
        errors: 500,
      })

      return from?.path === Path.ROOT ? next(from.path) : null
    }

    const rules = permission.permission(to.meta.serviceName).decode()

    // Set props to child components
    Object.keys(rules).forEach(ruleName => {
      // @ts-ignore
      to.params[ruleName] = rules[ruleName]
    })
  }

  return next()
}

export default permission
